import { render } from "./CartItem.vue?vue&type=template&id=2e5750d2&scoped=true"
import script from "./CartItem.vue?vue&type=script&lang=js"
export * from "./CartItem.vue?vue&type=script&lang=js"

import "./CartItem.vue?vue&type=style&index=0&id=2e5750d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e5750d2"]])

export default __exports__